export default {
	lastItem: (arr) => arr[arr.length - 1]
}